export default "__VITE_ASSET__vSGne5Eb__"